export default __webpack_public_path__ + "static/P87-88_GettyImages-1234025493-819f920c7f297ce756681fd6ec321dd0.jpg";